/**
 * Stable client id for a comparator that arrived (or was created) without one.
 *
 * Comparators are keyed by `id` across the R5 side-nav apparatus (nav groups,
 * detail view, focused section editors), so every code path that creates or
 * backfills a comparator must use the same generator. Falls back to a
 * timestamp+random id where `crypto.randomUUID` is unavailable (e.g. some jsdom
 * test envs).
 */
export function genComparatorId(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID()
  }
  return `cmp-${Date.now()}-${Math.random().toString(36).slice(2)}`
}
